import React from "react"

import HotTable from "../utils/hot-table";

class TableComponent extends React.Component {

	render() {
		return (
			<div className="investments-container">
				<HotTable
					ref="table"
					root="investment_themes"
					headers={false}
					data={this.props.data}
					tableDefinition={this.props.tableDefinition}
					onToggleTheme={this.props.onToggleTheme}
					previousYear={this.props.previousYear}
					currentUserType = {this.props.currentUserType}
				/>
			</div>
		)
	}

}

export default TableComponent



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/grants/table-component.js